// The Focused / Interrogate source drawer's back control. Delegates to the
// shared BackBar (inline variant — it sits inside the in-place drawer, not as a
// floating pill) so it matches every other back affordance. The drawer opened
// in place (nothing unmounted), so "back" just closes it and returns to the
// exact matched list / answer with the Focused session intact.

import { createElement } from "react";
import BackBar from "./BackBar";

export const FOCUSED_BACK_LABEL = "← Back to results";

interface Props {
  onBack: () => void;
}

export default function FocusedSourceBackBar({ onBack }: Props) {
  return createElement(BackBar, {
    label: FOCUSED_BACK_LABEL,
    hint: "Your search and answer are kept",
    onBack,
    variant: "inline",
  });
}

// Whether the Focused source-view back control should show: a source is open in
// the drawer. Set by BOTH a matched-list open and a citation click, cleared on
// return — one predicate governs both paths.
export function shouldShowSourceBack(sourcePanel: unknown): boolean {
  return sourcePanel != null;
}
